import React, { Component, Fragment } from "react";
import {Grid, List, } from '@material-ui/core';

import { FilterTabs } from './containers/FilterTabs';
import Pane from './containers/Pane';
import { LoadingProgress } from './containers/LoadingProgress';
import { RssReaderItem } from './RssReaderItem';

class RssReader extends Component {

  constructor() {
    super()
    this.state = {
      selectedFilter: 0,
    }
  }

  componentDidMount() {
    this.props.onRefreshRssFeeds();
  }

  onExternalLink(e, url) {
    e.preventDefault();
    window.open(url);
  }

  getRssByFilter() {
    return Object.entries(
      this.props.rssFeeds.reduce((feeds, filter) => {
        const {feed_id} = filter;
        feeds[feed_id] = feeds[feed_id]
        ? [...feeds[feed_id], filter]
        : [filter]

        return feeds;
      }, {})
    );
  }

  handleFilterSelected = selectedFilter => {
    this.setState({
      selectedFilter
    });
  };

  render() {
    const {
      rssFeeds,
      translations,
      appLanguage,
    } = this.props;
    const filters = this.props.filters ? this.props.filters.length > 1 ? this.props.filters : null : null;
    const { selectedFilter } = this.state;

    const rssReaderItems = selectedFilter ? this.getRssByFilter().map(([filter, feeds], i) => {
      return selectedFilter === filters[i].FEED_ID
      ? feeds.map((item) => {
        return (
          <RssReaderItem
            key={item.id ? item.id : 0}
            item={item}
            onClick={this.onExternalLink}
          />
        )
      })
      : null
    })
    : rssFeeds.map((item) => {
      return (
        <RssReaderItem
          key={item.id ? item.id : 0}
          item={item}
          onClick={this.onExternalLink}
          itemFeed={filters ? filters[item.feed_id -1] : null}
        />
      )
    });
    return (
      <Fragment>
        <Grid container justify="center">
          <Grid item xs sm={10} lg={9} xl={7}>
            <Pane
              header={translations.t_MODULE_RSSREADER_TITLE[appLanguage]}
              filterTabs={
                filters !== null ?
                <FilterTabs
                  filters={filters}
                  selectedFilter={selectedFilter}
                  onFilterSelect={this.handleFilterSelected}
                />
                : null
              }
            >
              <LoadingProgress data={rssFeeds}>
                <List>
                  {rssReaderItems}
                </List>
              </LoadingProgress>             
            </Pane>
          </Grid>
        </Grid>
      </Fragment>
    );
  }

}

export default RssReader;


// WEBPACK FOOTER //
// ./src/components/RssReader.js